import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';

export function OsasResendMijnKsyosQuestionnairesRead() {
    return <ReadForm />;
}
